import { Injectable } from "@angular/core";
import { errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class TimeincubbyService extends BaseService {

  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) {
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastTimeInCubby").subscribe(
      (data: any) => {
        console.log("broadcastTimeInCubby", data);
        let result: Array<any> = [];
        result = data;
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime && !widget.IfNoDataFound) {

          widget.dataLoaded = false;
          widget.chartOptions = this.chartOptions();
          widget.errorMessage = null;
          if(widget.IfNoDataFound){
            widget.errorMessage = errorMessages.noWidgetData;
          }else if (widget.IfNoDataFound == null) {
            widget.errorMessage = "Retrieving records. Please wait...";
          }
          else{
          let timeInCubby: any = result[0];

          widget.chartOptions.xAxis.data = ['2-4 Hrs', '4-8 Hrs', '8-24 Hrs', 'Above 24 hrs'];
          this.addDataSeries(widget.chartOptions, [timeInCubby.BTW_2_AND_4_HRS_COUNT,
            timeInCubby.BTW_4_AND_8_HRS_COUNT,
            timeInCubby.BTW_8_AND_24_HRS_COUNT,
            timeInCubby.ABOVE_24_HRS_COUNT
          ], 'Time in Cubby', 'bar')
          widget.errorMessage = null;
        }
      }
      widget.dataLoaded = true;
      this._commonService.lastUpdatedTime = lastUpdatedTime;
      },
      err => {
        console.log("listenFor broadcastTimeInCubby error", err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/timeincubby.service.ts